import { Controller } from "@hotwired/stimulus";

// Shows a full-size invoice scaled down to fit its frame, so it reads as a page on any screen
const PAPER_WIDTH = 760;

export default class extends Controller {
  static targets = ["paper"];

  connect() {
    this.observer = new ResizeObserver(() => this.fit());
    this.observer.observe(this.element);
    this.fit();
  }

  disconnect() {
    this.observer?.disconnect();
  }

  fit() {
    const scale = this.element.clientWidth / PAPER_WIDTH;
    this.paperTarget.style.width = `${PAPER_WIDTH}px`;
    this.paperTarget.style.transform = `scale(${scale})`;
    this.element.style.height = `${this.paperTarget.offsetHeight * scale}px`;
  }
}
